import { Box, styled } from '@creditas-ui/react'
import { AccordionHeader } from 'shared/ui/Accordion/AccordionHeader/AccordionHeader'

export const ContainerIconWarranty = styled(Box)`
  background: ${({ theme }) => theme.colors.neutral[10]};
  color: ${({ theme }) => theme.colors.neutral[60]};
  font-size: 12px;
  font-weight: 700;
  border-radius: 50%;

  width: 32px;
  height: 32px;
  padding: 0.4rem;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${({ theme }) => theme.colors.neutral[0]};
  }
`

export const ArrowIcon = styled(Box)`
  position: absolute;
  right: 32px;
  transition: transform 0.2s ease-out;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(0deg)' : 'rotate(180deg)')};

  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const AccordionHeaderStyled = styled(AccordionHeader)`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 2fr;
  grid-column-gap: 0px;
  grid-row-gap: 20px;
  grid-template-areas: "${'warranty '.repeat(2)}${'name '.repeat(8)} ${'arrow '}";
  margin: 0 -20px 0 -20px;

  @media screen and (min-width: 980px) {
    margin: 0;
    grid-column-gap: 20px;
    grid-template-areas: "${'warranty '.repeat(1)} ${'name '.repeat(
      3,
    )} ${'cpf '.repeat(2)} ${'step '.repeat(3)} ${'date '.repeat(2)} ${'arrow '}";
  }
`
